export const GET_ALL_INVOICES = 'GET_ALL_INVOICES'
export const GET_ALL_INVOICES_SUCCESS = 'GET_ALL_INVOICES_SUCCESS'
export const INVOICE_PRINT_DATA = 'INVOICE_PRINT_DATA'
export const INVOICE_PRINT_DATA_SUCCESS = 'INVOICE_PRINT_DATA_SUCCESS'